"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = Layout;
const jsx_runtime_1 = require("react/jsx-runtime");
const bind_1 = __importDefault(require("classnames/bind"));
const layout_m_scss_1 = __importDefault(require("./layout.m.scss"));
const cx = bind_1.default.bind(layout_m_scss_1.default);
/**
 * Контейнер, формирующий отступы по горизонтали в соответствии с дизайн-гайдами.
 * @param props Свойства.
 * @return Элемент.
 */
function Layout({ children, className, disabledOn = [], rootRef, ...rest }) {
    const rootClassName = cx('layout', disabledOn.length > 0 && disabledOn.map(key => `disabled-${key}`), className);
    return ((0, jsx_runtime_1.jsx)("div", { ...rest, ref: rootRef, className: rootClassName, children: children }));
}
//# sourceMappingURL=layout.js.map